module.exports = __webpack_public_path__ + "assets/img/33-m.586653d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/33-m.jpg
// module id = APX7
// module chunks = 0